export default {
  methods: {
    formateJS: function(d, h) {
      let date = this.$store.getters["configapp/appDateFormat"];
      let format = "";

      if (d) format += date;
      if (h) {
        switch (this.$store.getters["configapp/appHeureFormat"]) {
          case "H:i":
            format += " HH:MM";
            break;
          case "h:i":
            format += " hh:MM";
            break;
        }
      }

      return format;
    },
    convertDate: function(date, heure, d, h) {
      let dateStr = "";
      if (d) dateStr += this.$options.filters.formatDate(date);
      if (h) dateStr += " " + this.$options.filters.formatTime(heure);
      return dateStr;
    }
  }
};
